<script setup lang="ts">
import VueMarkdown from 'vue-markdown-render';

const props = defineProps<{
  themeKeys: {
    bg: string;
    fg: string;
    iconBg: string;
    cta1Bg: string;
    cta1Fg: string;
    cta2Bg: string;
    cta2Fg: string;
  };
  links: {
    pricing: string;
    signup: string;
  };
  cta: {
    title: string;
    feature1: {
      icon: string;
      text: string;
    };
    feature2: {
      icon: string;
      text: string;
    };
    pricing: string;
    signupCta: string;
    videoCta: string;
    videoLink: string;
  };
}>();
</script>

<template>
  <div
    class="px-4 py-8 md:px-8 md:py-16 xl:px-32 xl:py-36 relative overflow-hidden z-0"
    :style="{
      backgroundColor: props.themeKeys.bg,
      color: props.themeKeys.fg,
    }"
  >
    <div class="inner-container">
      <div class="flex flex-col md:flex-row gap-8 md:gap-12">
        <div class="w-full md:w-1/2">
          <h3 class="font-semibold text-4xl mb-8">{{ props.cta.title }}</h3>
          <div class="flex flex-row items-start mb-4 font-bold">
            <div
              class="rounded-full p-3 aspect-square inline-flex mr-4"
              :style="{
                backgroundColor: props.themeKeys.iconBg,
              }"
            >
              <Icon :name="`i-lucide-${props.cta.feature1.icon}`" :size="24" />
            </div>
            {{ props.cta.feature1.text }}
          </div>
          <div class="flex flex-row items-start mb-4 font-bold">
            <div
              class="rounded-full p-3 aspect-square inline-flex mr-4"
              :style="{
                backgroundColor: props.themeKeys.iconBg,
              }"
            >
              <Icon :name="`i-lucide-${props.cta.feature2.icon}`" :size="24" />
            </div>
            {{ props.cta.feature2.text }}
          </div>
          <div>
            <a class="flex flex-row items-center mb-4 font-bold" :href="props.links.pricing">
              <div class="p-3 aspect-square inline-flex items-center justify-center mr-4">
                <Icon :name="`i-lucide-arrow-right`" :size="24" />
              </div>
              <span>{{ props.cta.pricing }}</span>
            </a>
          </div>
        </div>
        <div class="w-full md:w-1/2">
          <div 
            class="
            flex flex-col items-center justify-center h-full gap-8 md:gap-8 mx-18 max-w-96 mx-auto
            *:text-2xl *:font-semibold *:rounded-2xl *:w-full *:text-center *:py-5 *:px-4
            *:hover:shadow
            "
          >
            <a
              :href="props.links.signup"
              :style="{
                backgroundColor: props.themeKeys.cta1Bg,
                color: props.themeKeys.cta1Fg,
              }"
            >
              {{ props.cta.signupCta }}
            </a>
            <a
              :href="props.cta.videoLink"
              :style="{
                backgroundColor: props.themeKeys.cta2Bg,
                color: props.themeKeys.cta2Fg,
              }"
              class="inline-flex flex flex-row gap-4 items-center justify-center"
            >
              <Icon name="i-lucide-circle-play" class="size-8" />
              {{ props.cta.videoCta }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <NuxtImg
      class="absolute bottom-0 right-0 translate-x-[55%] h-[90%] -z-1"
      src="/logo-system.svg"
    />
  </div>
</template>
